var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "createOrder_box" },
    [
      _c("div", { staticClass: "page_title" }, [_c("custom-breadcrumb")], 1),
      _vm._v(" "),
      _c("p", { staticClass: "con_title" }, [_vm._v("Customer")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "order_search" },
        [
          _c(
            "el-select",
            {
              attrs: {
                clearable: "",
                filterable: "",
                placeholder: "Retailer Name/Email"
              },
              on: {
                change: function($event) {
                  return _vm.changSelectHandel()
                }
              },
              model: {
                value: _vm.searchWords,
                callback: function($$v) {
                  _vm.searchWords = $$v
                },
                expression: "searchWords"
              }
            },
            _vm._l(_vm.retailerInfo, function(item) {
              return _c(
                "el-option",
                {
                  key: item.id,
                  attrs: { label: item.email, value: item.email }
                },
                [
                  _c("div", { staticClass: "flex re_text" }, [
                    _c("p", [_vm._v(_vm._s(item.email))]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticStyle: { color: "#8492a6", "font-size": "13px" }
                      },
                      [
                        _vm._v(_vm._s(item.storeName)),
                        _c("span", { staticClass: "span_margin" }, [
                          _vm._v("|")
                        ]),
                        _vm._v(_vm._s(item.phone))
                      ]
                    )
                  ])
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _vm.retailerInfo.length == 1
            ? _c(
                "div",
                _vm._l(_vm.retailerInfo, function(user, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "search_content flex" },
                    [
                      _c("div", { staticClass: "con_left" }, [
                        _c("p", { staticClass: "con_title" }, [
                          _vm._v("Customer")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "user_info" }, [
                          _vm._v("\n            Username: "),
                          _c("span", { staticClass: "info_text" }, [
                            _vm._v(_vm._s(user.username))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "user_info" }, [
                          _vm._v("\n            Email: "),
                          _c("span", { staticClass: "info_text" }, [
                            _vm._v(_vm._s(user.email))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "user_info" }, [
                          _vm._v("\n            Phone: "),
                          _c("span", { staticClass: "info_text" }, [
                            _vm._v(_vm._s(user.phone))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "user_info" }, [
                          _vm._v("\n            Store name: "),
                          _c("span", { staticClass: "info_text" }, [
                            _vm._v(_vm._s(user.storeName))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "con_right" }, [
                        _c("p", { staticClass: "con_title" }, [
                          _vm._v("\n            Ship Total\n            "),
                          _c("span", { on: { click: _vm.openAddress } }, [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/img/memo.png"),
                                alt: ""
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm.reInfo.addressFirstName &&
                          _vm.reInfo.addressLastName
                            ? _c("p", { staticClass: "user_info" }, [
                                _vm._v(
                                  _vm._s(_vm.reInfo.addressFirstName) +
                                    "  " +
                                    _vm._s(_vm.reInfo.addressLastName)
                                ),
                                _c("br")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.reInfo.address
                            ? _c("p", { staticClass: "user_info" }, [
                                _vm._v(_vm._s(_vm.reInfo.address)),
                                _c("br")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.reInfo.city &&
                          _vm.reInfo.province &&
                          _vm.reInfo.countryName &&
                          _vm.reInfo.postCode
                            ? _c("p", { staticClass: "user_info" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.reInfo.city) +
                                    ", " +
                                    _vm._s(_vm.reInfo.province) +
                                    ", " +
                                    _vm._s(_vm.reInfo.countryName) +
                                    "  " +
                                    _vm._s(_vm.reInfo.postCode)
                                ),
                                _c("br")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.reInfo.addressPhone
                            ? _c("p", { staticClass: "user_info" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.reInfo.areaCode) +
                                    _vm._s(_vm.reInfo.addressPhone) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    ]
                  )
                }),
                0
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("p", { staticClass: "con_title" }, [_vm._v("Order details")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "creat_order" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.orderDetails, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "date", label: "Item", width: "420" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", { staticClass: "prduct_box" }, [
                          _c("img", {
                            staticClass: "product_img",
                            attrs: { src: scope.row.img, alt: "" }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "product_info" }, [
                            _c("p", { staticClass: "product_name" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(scope.row.title) +
                                  "\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "product_size" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(scope.row.size) +
                                  "\n                "
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#8F8F8F",
                                    "margin-left": "15px",
                                    "font-size": "14px"
                                  }
                                },
                                [_vm._v(" " + _vm._s(scope.row.skuCode))]
                              )
                            ])
                          ])
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "name", label: "Wholesale Price", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "prduct_box flex_all" },
                          [
                            _c("el-input", {
                              staticClass: "price_input",
                              attrs: {
                                placeholder: "Wholesale Price",
                                oninput:
                                  "if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\\d+)\\.(\\d\\d).*$/, '$1$2.$3')}"
                              },
                              on: {
                                change: function(e) {
                                  return _vm.changeFobPrice(
                                    e,
                                    scope.$index,
                                    scope.row
                                  )
                                }
                              },
                              model: {
                                value: scope.row.price,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "price", $$v)
                                },
                                expression: "scope.row.price"
                              }
                            }),
                            _vm._v(" "),
                            scope.row["priceBefore"] != scope.row["price"]
                              ? _c(
                                  "div",
                                  {
                                    class:
                                      scope.row["priceBefore"] !=
                                      scope.row["price"]
                                        ? "dis_price dis_line"
                                        : "dis_price"
                                  },
                                  [
                                    _vm._v(
                                      "\n              $" +
                                        _vm._s(scope.row.priceBefore) +
                                        "\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "address", label: "Qty", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "prduct_box flex_all qty-left" },
                          [
                            _c("el-input", {
                              staticClass: "price_input",
                              attrs: {
                                oninput:
                                  "if(value){value=value.replace(/[^\\d]/g,'')}  if(value<1){value=1}",
                                placeholder: "Qty"
                              },
                              on: {
                                change: function(e) {
                                  return _vm.changeNum(
                                    e,
                                    scope.$index,
                                    scope.row
                                  )
                                }
                              },
                              model: {
                                value: scope.row.sum,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "sum", $$v)
                                },
                                expression: "scope.row.sum"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "address", label: "Total" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            "$" + _vm._s(_vm._f("fixed2")(scope.row.total))
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "order-delete",
                            on: {
                              click: function($event) {
                                return _vm.deleteOrder(scope.row)
                              }
                            }
                          },
                          [_c("i", { staticClass: "el-icon-close" })]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "add-btn",
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.addProductHandel()
                }
              }
            },
            [_vm._v("Add Product\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "product-bottom" }, [
        _c("div", { staticClass: "product-bottom-memo" }, [
          _c("div", [
            _c("div", { staticClass: "memo-text" }, [_vm._v("Memo")]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    rows: "8",
                    placeholder: "Fill out Memo",
                    maxlength: "500",
                    "show-word-limit": ""
                  },
                  nativeOn: {
                    keydown: function($event) {
                      return _vm.memoChange($event)
                    }
                  },
                  model: {
                    value: _vm.memo,
                    callback: function($$v) {
                      _vm.memo = $$v
                    },
                    expression: "memo"
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "product-bottom-price" }, [
          _vm.orderDetails && _vm.orderDetails.length > 0
            ? _c(
                "div",
                { staticClass: "end_box flex" },
                [
                  _c("div", { staticClass: "creat_text flex" }, [
                    _c("p", [_vm._v("Qty")]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.totalInfo["totalQuantity"]))])
                  ]),
                  _vm._v(" "),
                  _vm.brandName
                    ? _c("div", { staticClass: "creat_text flex" }, [
                        _c("p", [_vm._v(_vm._s(this.brandName))]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fixed2")(_vm.totalInfo["cifSubTotal"])
                            )
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "creat_text flex" }, [
                    _c("p", { staticClass: "brown_text" }, [
                      _vm._v("Product discount")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "brown_text" }, [
                      _c("span", { staticClass: "black_text" }, [_vm._v("-")]),
                      _vm._v(
                        "$" +
                          _vm._s(
                            _vm._f("fixed2")(
                              _vm.totalInfo["totalPriceProductDicounted"]
                            )
                          ) +
                          "\n          "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "creat_text flex" }, [
                    _c("p", { staticClass: "brown_text" }, [
                      _vm._v("Bulk order discount")
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticClass: "brown_text" },
                      [
                        _c("span", { staticClass: "black_text" }, [
                          _vm._v("-$")
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "price_input brown_text",
                          attrs: {
                            oninput:
                              "if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\\d+)\\.(\\d\\d).*$/, '$1$2.$3')}",
                            placeholder: "",
                            clearable: ""
                          },
                          on: { change: _vm.changePrice },
                          model: {
                            value: _vm.totalInfo["totalPriceOrderDiscounted"],
                            callback: function($$v) {
                              _vm.$set(
                                _vm.totalInfo,
                                "totalPriceOrderDiscounted",
                                $$v
                              )
                            },
                            expression: "totalInfo['totalPriceOrderDiscounted']"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm.totalInfo["totalPriceOrderDiscountedShopvidi"]
                    ? _c("div", { staticClass: "creat_text flex" }, [
                        _c("p", { staticClass: "brown_text" }, [
                          _vm._v("Offered by ShopVidi")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "brown_text" }, [
                          _c("span", { staticClass: "black_text" }, [
                            _vm._v("-$")
                          ]),
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("fixed2")(
                                  _vm.totalInfo[
                                    "totalPriceOrderDiscountedShopvidi"
                                  ]
                                )
                              ) +
                              "\n          "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "creat_text flex",
                      staticStyle: { "font-weight": "600" }
                    },
                    [
                      _c("p", [_vm._v("Subtotal")]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "$" +
                            _vm._s(_vm._f("fixed2")(_vm.totalInfo["subTotal"]))
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "creat_text flex" }, [
                    _c("p", { staticClass: "brown_text" }, [
                      _vm._v("Shipping")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "brown_text" }, [
                      _c("span", { staticClass: "black_text" }, [
                        _vm._v(_vm._s(_vm.shippingPrice || 0))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "creat_text flex" }, [
                    _c("p", { staticClass: "brown_text" }, [
                      _vm._v("Shipping discount (By Brand)")
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticClass: "brown_text" },
                      [
                        _c("span", { staticClass: "black_text" }, [
                          _vm._v("-$")
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "price_input brown_text",
                          attrs: {
                            oninput:
                              "if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\\d+)\\.(\\d\\d).*$/, '$1$2.$3')}",
                            placeholder: "",
                            clearable: ""
                          },
                          on: { change: _vm.handleShippingDiscount },
                          model: {
                            value: _vm.totalInfo["shippingDiscount"],
                            callback: function($$v) {
                              _vm.$set(_vm.totalInfo, "shippingDiscount", $$v)
                            },
                            expression: "totalInfo['shippingDiscount']"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "creat_text blod_text flex" }, [
                    _c("p", [_vm._v("Total Amount")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm._f("fixed2")(_vm.totalInfo["payAmount"]))
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "add-btn",
                      attrs: {
                        type: "primary",
                        loading: _vm.createOrderLoading
                      },
                      on: {
                        click: function($event) {
                          return _vm.createOrder()
                        }
                      }
                    },
                    [_vm._v("Create Order\n        ")]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "60%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "dialog_box" },
            [
              _c("p", { staticClass: "con_title dialog_title" }, [
                _vm._v("Add Products")
              ]),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "search_input2",
                attrs: {
                  "prefix-icon": "el-icon-search",
                  placeholder: "Search Product Name/SKU",
                  clearable: ""
                },
                on: {
                  change: function($event) {
                    return _vm.loadGoodsDetail()
                  }
                },
                model: {
                  value: _vm.searchSpuWords,
                  callback: function($$v) {
                    _vm.searchSpuWords = $$v
                  },
                  expression: "searchSpuWords"
                }
              }),
              _vm._v(" "),
              _vm._l(_vm.allProduct, function(node, index) {
                return _c(
                  "el-collapse",
                  {
                    key: index,
                    attrs: { id: "cust_tablist_" + node.id },
                    model: {
                      value: _vm.activeNames,
                      callback: function($$v) {
                        _vm.activeNames = $$v
                      },
                      expression: "activeNames"
                    }
                  },
                  [
                    _c(
                      "el-collapse-item",
                      { attrs: { name: node.id, id: node.id } },
                      [
                        _c(
                          "template",
                          { slot: "title" },
                          [
                            _c(
                              "el-checkbox",
                              {
                                attrs: { id: "cust_spu_" + node.id },
                                on: {
                                  change: function($event) {
                                    return _vm.handleCheckAllChange(
                                      $event,
                                      node.id,
                                      node.skuAll
                                    )
                                  }
                                },
                                model: {
                                  value: node.skuAll,
                                  callback: function($$v) {
                                    _vm.$set(node, "skuAll", $$v)
                                  },
                                  expression: "node.skuAll"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "custom-tree-node flex" },
                                  [
                                    _c("img", {
                                      staticClass: "sku_img",
                                      attrs: { src: node.imgUrl, alt: "" }
                                    }),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "spu_title" }, [
                                      _vm._v(_vm._s(node.title))
                                    ])
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-checkbox-group",
                          {
                            staticClass: "checkout_style flex",
                            on: {
                              change: function($event) {
                                return _vm.handleCheckedCitiesChange(
                                  $event,
                                  node.id
                                )
                              }
                            },
                            model: {
                              value: _vm.checkedCities,
                              callback: function($$v) {
                                _vm.checkedCities = $$v
                              },
                              expression: "checkedCities"
                            }
                          },
                          _vm._l(node.skus, function(sku, i) {
                            return _c(
                              "el-checkbox",
                              { key: i, attrs: { label: sku.id } },
                              [
                                _c("div", { staticClass: "sku_size flex" }, [
                                  _c("p", [_vm._v(_vm._s(sku.character))]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c("span", [_vm._v(_vm._s(sku.skuCode))]),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(sku.vdSku))]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v("$" + _vm._s(_vm.getPrice(sku)))
                                    ])
                                  ])
                                ])
                              ]
                            )
                          }),
                          1
                        )
                      ],
                      2
                    )
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm.allProduct.length == 0
                ? _c("div", { staticClass: "more_text" }, [
                    _vm._v("No results found for " + _vm._s(_vm.searchSpuWords))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.allProduct.length > 0
                ? _c("div", { staticClass: "more_text" }, [
                    _vm._v(
                      "Default Display 30 items, you could search for more"
                    )
                  ])
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.addProduct()
                    }
                  }
                },
                [_vm._v("Add")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.allProduct.length == 0
            ? _c("p", { staticClass: "all_select_num" }, [
                _vm._v(_vm._s(_vm.allProduct.length) + "Variant Selected")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.allProduct.length > 0
            ? _c("p", { staticClass: "all_select_num" }, [
                _vm._v(_vm._s(_vm.checkedCities.length) + "Variant Selected")
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.successVisible,
            "close-on-click-modal": false,
            "show-close": false,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.successVisible = $event
            },
            close: function($event) {
              return _vm.backOrderList()
            }
          }
        },
        [
          _c(
            "span",
            {
              staticClass: "back_icon",
              on: {
                click: function($event) {
                  return _vm.backOrderList()
                }
              }
            },
            [_c("i", { staticClass: "el-icon-arrow-left" }), _vm._v("Back")]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "success_text" }, [
            _vm._v("Order modified successfully")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex_all" },
            [
              _c(
                "el-button",
                {
                  staticClass: "back_button",
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.backOrderList()
                    }
                  }
                },
                [
                  _vm._v(
                    "Back Order List (" + _vm._s(_vm.seconds) + ")\n      "
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.notEnoughVisible,
            "close-on-click-modal": false,
            "show-close": false,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.notEnoughVisible = $event
            },
            close: function($event) {
              return _vm.backOrderList()
            }
          }
        },
        [
          _c(
            "span",
            {
              staticClass: "back_icon",
              on: {
                click: function($event) {
                  return _vm.backOrderList()
                }
              }
            },
            [_c("i", { staticClass: "el-icon-arrow-left" }), _vm._v("Back")]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "success_text" }, [
            _vm._v("Order modified successfully")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "not_enough" }, [
            _vm._v(
              "The client doesn’t have enough credit, he could pay this order with card."
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex_all" },
            [
              _c(
                "el-button",
                {
                  staticClass: "back_button",
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.backOrderList()
                    }
                  }
                },
                [
                  _vm._v(
                    "Back Order List (" + _vm._s(_vm.seconds) + ")\n      "
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("Address", {
            ref: "address",
            attrs: { addressMessage: _vm.addressMessage }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "creat_text flex" }, [
      _c("div", { staticClass: "split" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "creat_text flex" }, [
      _c("div", { staticClass: "split" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13437c1d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13437c1d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/createOrder.vue
// module id = Dy6z
// module chunks = 2